import { setTabVisibility as setVisibility } from '@client/redux/modules/clientDevice/actions';

export const checkVisibilityAPI = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    if (typeof document.hidden !== 'undefined') {
        return {
            hidden: 'hidden',
            visibilityChange: 'visibilitychange',
        };
    }
    else if (typeof document.msHidden !== 'undefined') {
        return {
            hidden: 'msHidden',
            visibilityChange: 'msvisibilitychange',
        };
    }
    else if (typeof document.webkitHidden !== 'undefined') {
        return {
            hidden: 'webkitHidden',
            visibilityChange: 'webkitvisibilitychange',
        };
    }

    return {};
};

export const getVisibilityChangeEventName = () => {
    const { visibilityChange } = checkVisibilityAPI();

    return visibilityChange;
};

export const getHiddenPropName = () => {
    const { hidden } = checkVisibilityAPI();

    return hidden;
};

export const setTabVisibility = (store) => {
    if (typeof window === 'undefined') {
        return;
    }
    const hidden = getHiddenPropName();

    store.dispatch(setVisibility(!document[hidden]));
};
